// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RotaProtegida from './components/RotaProtegida';
import Layout from './components/Layout';
import './styles/global.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Agenda from './pages/Agenda';
import Projetos from './pages/Projetos';
import Metas from './pages/Metas';
import Financeiro from './pages/Financeiro';
import Relatorios from './pages/Relatorios';
import Colaboradores from './pages/Colaboradores';
import Configuracoes from './pages/Configuracoes';
import CRM from './pages/CRM';
import Playbook from './pages/Playbook';
import Casos from './pages/Casos';
import Prazos from './pages/Prazos';
import Conteudo from './pages/Conteudo';
import ClientPortal from './pages/ClientPortal';
import CasoPortal from './pages/CasoPortal';
import AreaCliente from './pages/AreaCliente';
import PlaybookCliente from './pages/PlaybookCliente';
import RelatorioCliente from './pages/RelatorioCliente';
import RoteirosCliente from './pages/RoteirosCliente';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/portal/:token" element={<ClientPortal />} />
          <Route path="/meu-caso/:token" element={<CasoPortal />} />
          <Route path="/" element={<RotaProtegida><Layout /></RotaProtegida>}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/novo" element={<Leads modoNovo />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="crm" element={<CRM />} />
            <Route path="playbook" element={<Playbook />} />
            <Route path="projetos" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Projetos /></RotaProtegida>} />
            <Route path="casos" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Casos /></RotaProtegida>} />
            <Route path="prazos" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Prazos /></RotaProtegida>} />
            <Route path="conteudo" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Conteudo /></RotaProtegida>} />
            <Route path="area-cliente" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><AreaCliente /></RotaProtegida>} />
            <Route path="playbook-cliente/:projetoId" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><PlaybookCliente /></RotaProtegida>} />
            <Route path="relatorio-cliente/:projetoId" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><RelatorioCliente /></RotaProtegida>} />
            <Route path="roteiros-cliente/:projetoId" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><RoteirosCliente /></RotaProtegida>} />
            <Route path="metas" element={<Metas />} />
            <Route path="financeiro" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Financeiro /></RotaProtegida>} />
            <Route path="relatorios" element={<RotaProtegida perfisPermitidos={['admin','gestor']}><Relatorios /></RotaProtegida>} />
            <Route path="colaboradores" element={<RotaProtegida perfisPermitidos={['admin']}><Colaboradores /></RotaProtegida>} />
            <Route path="configuracoes" element={<RotaProtegida perfisPermitidos={['admin']}><Configuracoes /></RotaProtegida>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
